import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import InfoDialog from 'routes/Documents/components/InfoDialog';

import { table, th, td } from './InfoDialog15D.less';

const infoTemplate = (
  <div>
    <p>
      <FormattedMessage id="qualityoflife.15D.info.p1" />
    </p>
    <table className={table}>
      <tbody>
        <tr>
          <th className={th}>
            <FormattedMessage id="qualityoflife.description.table.header1" />
          </th>
          <th className={th}>
            <FormattedMessage id="qualityoflife.description.table.header2" />
          </th>
        </tr>
        <tr>
          <td className={td}>
            <FormattedMessage id="qualityoflife.description.muchBetter" />
          </td>
          <td className={td}>&gt;.035</td>
        </tr>
        <tr>
          <td className={td}>
            <FormattedMessage id="qualityoflife.description.slightlyBetter" />
          </td>
          <td className={td}>.015 - .035</td>
        </tr>
        <tr>
          <td className={td}>
            <FormattedMessage id="qualityoflife.description.muchTheSame" />
          </td>
          <td className={td}>&gt;&minus;.015 & &lt;.015</td>
        </tr>
        <tr>
          <td className={td}>
            <FormattedMessage id="qualityoflife.description.slightlyWorse" />
          </td>
          <td className={td}>(&minus;.035) - (&minus;.015)</td>
        </tr>
        <tr>
          <td className={td}>
            <FormattedMessage id="qualityoflife.description.muchWorse" />
          </td>
          <td className={td}>&lt;&minus;.035</td>
        </tr>
      </tbody>
    </table>
    <h4 style={{ marginTop: '1rem' }}>
      <FormattedMessage id="qualityoflife.15D.info.h1" />
    </h4>
    <ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul1.li1" />
      </li>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul1.li2" />
      </li>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul1.li3" />
      </li>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul1.li4" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul1.li4.ul.li1" />
        </li>
      </ul>
    </ul>

    <h4 style={{ marginTop: '1rem' }}>
      <FormattedMessage id="qualityoflife.15D.info.h2" />
    </h4>
    <p>
      <FormattedMessage id="qualityoflife.15D.info.p2" />
    </p>
    <ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul2.li1" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul2.li1.ul.li1" />
        </li>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul2.li1.ul.li2" />
        </li>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul2.li1.ul.li3" />
        </li>
      </ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul2.li2" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul2.li2.ul.li1" />
        </li>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul2.li2.ul.li2" />
        </li>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul2.li2.ul.li3" />
        </li>
      </ul>
    </ul>

    <h4 style={{ marginTop: '1rem' }}>
      <FormattedMessage id="qualityoflife.15D.info.h3" />
    </h4>
    <p>
      <FormattedMessage id="qualityoflife.15D.info.p3" />
    </p>
    <ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul3.li1" />
      </li>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul3.li2" />
      </li>
    </ul>

    <h4 style={{ marginTop: '1rem' }}>
      <FormattedMessage id="qualityoflife.15D.info.h4" />
    </h4>
    <ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul4.li1" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul4.li1.ul.li1" />
        </li>
      </ul>
    </ul>

    <h4 style={{ marginTop: '1rem' }}>
      <FormattedMessage id="qualityoflife.15D.info.h5" />
    </h4>
    <ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul5.li1" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul5.li1.ul.li1" />
        </li>
      </ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul5.li2" />
      </li>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul5.li3" />
      </li>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul5.li4" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul5.li4.ul.li1" />
        </li>
      </ul>
      <li>
        <FormattedMessage id="qualityoflife.15D.info.ul5.li5" />
      </li>
      <ul>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul5.li5.ul.li1" />
        </li>
        <li>
          <FormattedMessage id="qualityoflife.15D.info.ul5.li5.ul.li2" />
        </li>
      </ul>
    </ul>
  </div>
);

const InfoDialog15D = ({ ...props }) => (
  <InfoDialog value={infoTemplate} title="qualityoflife.15D.infoTitle" {...props} />
);

InfoDialog15D.propTypes = {
  buttonStyle: PropTypes.object,
  viewStyle: PropTypes.object,
};

export default InfoDialog15D;
